// Crop rasters cover the overview; interactive crop polygons start at street scale.
export const CC_MIN_TILE_ZOOM = 2;
export const CC_MIN_VECTOR_ZOOM = 14;
export const CC_MAX_TILE_ZOOM = CC_MIN_VECTOR_ZOOM - 1;

// The authenticated v2 endpoint has different limits from the legacy WMS.
export const CC_V2_MIN_TILE_ZOOM = 5;
export const CC_V2_MAX_TILE_ZOOM = 18;
export const CC_V2_MAX_NATIVE_ZOOM = 13;
